export default __webpack_public_path__ + "14bcdaf4f5fc955f6d6f5660a350eef9.png";